import { WorksheetImagesAndRemarksSection, WorksheetTestedBySection } from 'Components/Worksheets/Core';
import { ListFieldSection, PageSection, SectionGroup } from '../../../Layout';
import ids from '../../QestIds';

import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import {
  CompactionDataSection,
  CompactionEquipmentSection,
  CompactionWaterContentDeterminationEquipmentSection,
  MetricCompactionCwdSection,
  TestFractionSpecificGravitySection,
} from '../Shared';
import {
  MetricCompactionWaterContentDeterminationGridSection,
  OversizeCorrectionSection,
  OversizeDeterminationSection,
  PreparationSection,
  ResultsSection,
} from './Sections';

const qestIds = [ids.maximumDryDensity.AASHTO_T99.rev2015_metric, ids.maximumDryDensity.AASHTO_T180.rev2015_metric];

let AashtoMetricMddWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PreparationSection />
      <OversizeDeterminationSection />
      <NamePrefixModifier appendNamePrefix="Preparation.SpecificGravityCoarse">
        <OversizeCorrectionSection />
      </NamePrefixModifier>

      <NamePrefixModifier appendNamePrefix="TestFractionSpecificGravity">
        <TestFractionSpecificGravitySection />
      </NamePrefixModifier>

      <PageSection heading="Compaction">
        <CompactionEquipmentSection />
        <SectionGroup heading="Compaction Data">
          <MetricCompactionCwdSection />
          <ListFieldSection name="TestPortions" /* for messages relating to test portions */ />
          <CompactionDataSection />
        </SectionGroup>
        <SectionGroup heading="Moisture Content Determination">
          <CompactionWaterContentDeterminationEquipmentSection />
          <MetricCompactionWaterContentDeterminationGridSection />
        </SectionGroup>
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSection />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AashtoMetricMddWorksheet.qestIds = qestIds;

export default AashtoMetricMddWorksheet;
